package ai.wagemix.net.models.firebase

import kotlinx.serialization.Serializable

interface WMFirebaseMix {
    val title: String
    val occupations: List<Occupation>
    val isDeleted: Boolean

    interface Occupation {
        val id: Int
        val percentage: Double
        val justification: String
        val isEnabled: Boolean
        companion object
    }

    companion object
}

@Serializable
@ConsistentCopyVisibility
data class KxsWMFirebaseMix internal constructor(
    override val title: String,
    override val occupations: List<Occupation> = emptyList(),
    override val isDeleted: Boolean = false
): WMFirebaseMix {
    @Serializable
    @ConsistentCopyVisibility
    data class Occupation internal constructor(
        override val id: Int,
        override val percentage: Double,
        override val justification: String,
        override val isEnabled: Boolean = true
    ): WMFirebaseMix.Occupation
}

fun WMFirebaseMix.Companion.kxs(
    title: String,
    occupations: List<WMFirebaseMix.Occupation>,
    isDeleted: Boolean = false
): KxsWMFirebaseMix {
    return KxsWMFirebaseMix(
        title = title,
        occupations = occupations.map { it.toKxs() },
        isDeleted = isDeleted
    )
}

fun WMFirebaseMix.toKxs(): KxsWMFirebaseMix = when (this) {
    is KxsWMFirebaseMix -> this
    else -> WMFirebaseMix.kxs(
        title = title,
        occupations = occupations,
        isDeleted = isDeleted
    )
}

fun WMFirebaseMix.Occupation.Companion.kxs(
    id: Int,
    percentage: Double,
    justification: String,
    isEnabled: Boolean = true
): KxsWMFirebaseMix.Occupation {
    return KxsWMFirebaseMix.Occupation(id = id, percentage = percentage, justification = justification, isEnabled = isEnabled)
}

fun WMFirebaseMix.Occupation.toKxs(): KxsWMFirebaseMix.Occupation = when (this) {
    is KxsWMFirebaseMix.Occupation -> this
    else -> KxsWMFirebaseMix.Occupation(id = id, percentage = percentage, justification = justification, isEnabled = isEnabled)
}

